
import { useScript, ScriptStatus, AddScriptTo } from "src/utils/hooks/useScript";
import { noop } from "src/utils/noop";
import {
    MOXO_SCRIPT_LOAD_ERROR,
    MOXO_SCRIPT_LOAD_SUCCESS,
    MOXO_TOKEN_ERROR,
    MOXO_TOKEN_SUCCESS,
    createMessage,
} from "src/constants/messages";
import { MoxoConfig } from "./Client/types";
import { MoxoAccessManager } from "./Client/MoxoAccessManager";

export interface UseMoxoProps {
    isDisabled: boolean;
    isLoading: boolean;
    config: MoxoConfig;
    onMoxoSubmitError?: (error: string) => void;
    onMoxoSubmitSuccess?: (token: string) => void;
}

export type MoxoProps = UseMoxoProps;

interface UseMoxoReturn {
    onClick: () => void;
    onLoad: () => void;
}

export function useMoxo(props: MoxoProps): UseMoxoReturn {
    const {
        isDisabled,
        isLoading,
        config,
        onMoxoSubmitError = noop,
        onMoxoSubmitSuccess,
    } = props;

    const status = useScript(
        `${config.domain}/web/websdk/dist/mepsdk.js`,
        AddScriptTo.HEAD,
    );

    const handleMoxoInteraction = (
        successMessageFn: (...args: any[]) => string,
        errorMessageFn: (...args: any[]) => string,
        actionCallback?: () => void
    ) => {
        if (isDisabled || isLoading) return;

        if (status === ScriptStatus.READY) {
            if ("mepsdk" in window) {
                try {
                    if (typeof onMoxoSubmitSuccess === "function") {
                        actionCallback?.();
                        onMoxoSubmitSuccess(createMessage(successMessageFn));
                    } else {
                        console.log("UseMoxo: no callback on success");
                    }
                } catch (err) {
                    onMoxoSubmitError(createMessage(errorMessageFn));
                }
            } else {
                console.log("mepsdk is not in the window");
                onMoxoSubmitError(createMessage(errorMessageFn));

            }
        }
    };

    const setupChat = () => {
        handleMoxoInteraction(
            MOXO_SCRIPT_LOAD_SUCCESS,
            MOXO_SCRIPT_LOAD_ERROR
        );
    };

    const launchChat = () => {
        handleMoxoInteraction(
            MOXO_TOKEN_SUCCESS,
            MOXO_TOKEN_ERROR,
            () => {
                const moxoAccessManager = new MoxoAccessManager();
                const instance = moxoAccessManager.client(config)
                instance?.launch(config.channelId);
            }
        );
    };

    return { onClick: setupChat, onLoad: launchChat };
}